import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'

export type DepositValidationResult = {
  deposit?: string[]
}

export interface DepositProps {
  showLabelWithTooltip?: boolean
}

const Deposit: React.FC<FieldProps<DepositValidationResult> & DepositProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = 'grid-item one-whole margin-top-l',
  showLabelWithTooltip = false,
}) => {
  const { t } = useTranslation()

  const labelWithTooltip = (
    <LabelWithTooltip
      inputId='deposit'
      labelText={t('wizard.screen.costs.deposit')}
      tooltipContent={<PopoverContent translationKey='wizard.screen.costs.depositHint' />}
      showMandatory={false}
    />
  )

  const labelWithoutTooltip = <span>{t('wizard.screen.costs.deposit')}</span>

  return (
    <div className={wrapperClassName}>
      {showLabelWithTooltip && labelWithTooltip}
      <TextInput
        id='deposit'
        propertyName='deposit'
        placeholder=''
        label={showLabelWithTooltip ? '' : labelWithoutTooltip}
        value={insertionData.deposit}
        maxLength={50}
        type='tel'
        style={{}}
        errors={validationMessages!.deposit ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default Deposit
